import toast from "react-hot-toast";
import { Link } from "react-router-dom";

import { getBaseUrl } from "simplydo/core/helpers";
import { fileDownload } from "simplydo/core/storage";

import { useMe } from "../hooks";

type DownloadLinkProps = {
  url: string;
  name: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const downloadUrlRegex = /^https:\/\/[a-z-]{2,16}\.simplydo\.co\.uk\/download/;

export const DownloadLink = ({
  url,
  name,
  children,
  className,
  style,
}: DownloadLinkProps) => {
  const user = useMe();

  const baseUrl = getBaseUrl(
    import.meta.env.VITE_STAGE,
    user?.ownerOrganisation,
  );
  const isSimplyDoDownloadLink =
    url.startsWith(baseUrl + "/download") || url.match(downloadUrlRegex);

  if (isSimplyDoDownloadLink) {
    const localHref = url.replace(baseUrl, "");

    return (
      <Link
        to={localHref}
        onClick={(e) => {
          if (!user || !url) return;
          e.stopPropagation();
          e.preventDefault();

          fileDownload(user, url, name, (error) => {
            if (error.status === 404) {
              toast.error("This file no longer exists or has been removed.");
              return;
            }
            toast.error("Could not download file, please try again later.");
          });
        }}
        className={className}
        style={style}
      >
        {children}
      </Link>
    );
  }

  return (
    <a
      href={url}
      download={name}
      rel="noopener noreferrer"
      target="_blank"
      className={className}
      style={style}
    >
      {children}
    </a>
  );
};
